<template>
    <div class="modal fade" id="restaurant_orders_modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" ref="modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="myModalLabel">Restaurant's Orders History</h4>
                </div>
                <div class="modal-body">

                    <div class="row">
                        <div class="col-lg-12">
                            <div v-bind:class="'sk-spinner sk-spinner-three-bounce ' + isHideSpinner">
                                <div class="sk-bounce1"></div>
                                <div class="sk-bounce2"></div>
                                <div class="sk-bounce3"></div>
                            </div>
                        </div>
                    </div>

                <div class="table-responsive" style="overflow: auto">
                    <table class="table table-striped table-bordered table-hover responsive" id="dtTable">
                        <thead>
                        <tr>
                            <th>Order ID</th>
                            <th>Restaurant</th>
                            <th>Branch</th>
                            <th>Order type</th>
                            <th>Customer Area</th>
                            <th>City</th>
                            <th>Total Amount</th>
                            <th>Order Date</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="order in orders" :key="order.id" >
                            <th>{{ order.id }}</th>
                            <td>{{ order.branchesByBranchId.restaurantsByRestaurantId.name }}</td>
                            <td>{{ order.branchesByBranchId.areasByAreaId.name }}</td>
                            <td>{{ order.orderTypesByOrderTypeId.type}}</td>
                            <td>{{ getCustomerArea(order) }}</td>
                            <td>{{ getCustomerCity(order) }}</td>
                            <td>{{ order.totalPrice }}</td>
                            <td>{{ order.created }}</td>

                        </tr>

                        </tbody>
                    </table>
                </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    /* eslint-disable */
    export default {
        name: "RestaurantOrdersDetail",
        data: function () {
            return {
                orders:[],
                customerName:"",
                isHideSpinner: "",
            };
        },
        mounted: function () {
            $(this.$refs.modal).on("hidden.bs.modal",function () {
                this.orders=null;
            });
        },
        methods: {
            load: async function (billingId) {
                $("#restaurant_orders_modal").modal("show");
                this.orders=[];
                this.isHideSpinner="";
                let resp= await this.$http.get(this.$store.state.mainAppURL + "billings/get_all_orders_of_billing/" + billingId);
                this.orders= resp.data;
                this.isHideSpinner="hide";
            },
            getCustomerArea: function(order){
              if(order.orderTypesByOrderTypeId.id=== 1)
                return "N/A";
              if(order.customerAddressesByCustomerAddressId != null)
                return order.customerAddressesByCustomerAddressId.address;
              if(order.dvmAddress !=null)
                return order.dvmAddress.address;
            },
            getCustomerCity: function(order){
              if(order.orderTypesByOrderTypeId.id === 1)
                return "N/A";
              if(order.customerAddressesByCustomerAddressId != null)
                return order.customerAddressesByCustomerAddressId.areasByAreaId.citiesByCityId.city;
              if(order.dvmAddress !=null)
                return order.dvmAddress.citiesByCityId.city;
            },
        }

    }
</script>

<style scoped>

    @media screen and (min-width: 768px) {
        .modal-dialog {
            width: 800px; /* New width for default modal */
            min-height: 800px !important;
        }
        .modal-content {

            /* 90% of window height */
            min-height: 90%;
        }
    }


</style>
